import React, { useCallback, useState } from 'react';
import debounce from 'lodash/debounce';
import { PlaceSelect, Place } from '@app/form';

export interface GeolocationFilterType {
  location?: { lon: number; lat: number };
  radius?: number;
  name?: string;
  address?: string;
}

export interface GeolocationTypeFilterValue {
  name: string;
  operator: string;
  type: string;
  value: GeolocationFilterType | null;
  filterEditorProps?: any;
}

interface Props {
  filterValue?: GeolocationTypeFilterValue;
  filterDelay?: number;
  readOnly?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  rtl?: boolean;
  theme?: string;
  onChange?: Function;
  render?: Function;
  placeholder?: string;
  inputRef?: any;
  filterEditorProps?: any;
}

export const GeolocationFilter = ({
  filterValue,
  filterDelay,
  onChange,
  render,
}: Props) => {
  const [value, setValue] = useState<GeolocationFilterType | null>(
    filterValue?.value || null,
  );

  const onValueChange = useCallback(
    debounce(
      (val: GeolocationFilterType | null) => {
        onChange &&
          onChange({
            ...filterValue,
            value: val,
          });
      },
      filterDelay,
      {
        leading: false,
        trailing: true,
      },
    ),
    [onChange, filterValue, value],
  );

  const onInputChange = useCallback(
    (_place?: Place | Place[] | null) => {
      if (!_place || (Array.isArray(_place) && !_place.length)) {
        onValueChange(null);
        setValue(null);
        return;
      }
      const place = Array.isArray(_place) ? _place[0] : _place;
      const lat = place?.geometry?.location?.lat();
      const lon = place?.geometry?.location?.lng();

      const val: GeolocationFilterType = {
        location: lat && lon ? { lat, lon } : undefined,
        radius: 100,
        name: place?.name,
        address: place?.formatted_address,
      };
      onValueChange(val);
      setValue(val);
    },
    [onValueChange, setValue],
  );

  return (
    render && render(<PlaceSelect onValueChange={onInputChange} noMargin />)
  );
};
